<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    Adding international contacts' phone numbers
                </h2>
                <h3>
                    To add an international contact's phone number
                </h3>
                <ol>
                    <li>
                        Go to your phone's Contacts.
                    </li>
                    <li>
                        When adding the contact's phone number, start by entering a plus sign (+).
                    </li>
                    <li>
                        Enter the country code, followed by the full phone number.
                    </li>
                    <ul>
                        <li>
                            Note: A country code is a numerical prefix that needs to be entered before the full national
                            phone number to make a call to another country. You can search online to find the country
                            code you need.
                        </li>
                    </ul>
                </ol>
                <p>
                    Note:
                </p>
                <ul>
                    <li>
                        Make sure to remove any leading 0's or special calling codes.
                    </li>
                    <li>
                        If you meant to add a local (in country) phone number instead to your phone's address book,
                        enter the number as if you were calling your contact on the phone.
                    </li>
                </ul>


            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
